import script from "./BaseToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseToggle.vue?vue&type=script&setup=true&lang=js"

import "./BaseToggle.vue?vue&type=style&index=0&id=297d3594&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-297d3594"]])

export default __exports__